<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle"></span>
        <h3 class="page-title">Laporan Peserta Doa</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card mb-4">
          <div class="card-body p-1 pb-3" style="overflow-x:scroll">
            <d-row style="margin:auto;display:none;">
              <d-col md="3"  class="form-group" style="text-align:left">
                Asal Gereja
                <d-select v-model="gky" :options="gkys" style="padding-left:1px" />
              </d-col>
            </d-row>
            <d-row style="margin:auto">
              <d-col md="6"  class="form-group">
                <label for="feSearch">Cari</label>
                <d-form-input type="text" id="feInputSearch" placeholder="Kata Kunci" v-model.trim="search" />
              </d-col>
            </d-row>
            <br/><br/>
            <d-row style="margin:auto">
              <d-col md="6"  class="form-group">
                <label for="feGo">&nbsp;</label>
                <button type="button" class="btn-primary" @click="update_data"><i class="material-icons">send</i> Kirim</button>
                <label v-if="show_excel" for="feGo">&nbsp;</label>
                <button v-if="show_excel" type="button" class="btn-primary is-hidden-mobile" @click="xls"><i class="material-icons">border_all</i> Excel</button>
              </d-col>
            </d-row>
            <d-row>
            <d-col md="6"  class="form-group">
            </d-col>
            </d-row>
        <b-table
            id="dtable"
            :data="isEmpty ? [] : data"
            :loading="loading"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :opened-detailed="opened"
            detailed
            detail-key="id"
            >

            <template slot-scope="props">
                <b-table-column field="id" label="Id" >
                    <span class="tag is-success">
                    {{ props.row.id }}
                    </span>
                </b-table-column>
                <b-table-column field="fullname" label="Nama Lengkap" >
                    {{ props.row.fullname }}
                </b-table-column>
                <b-table-column field="jid" label="HP" style="text-align:right" >
                    {{ (props.row.jid=='0000000')? '':props.row.jid }}
                </b-table-column>
                <!--b-table-column field="allnite2025" label="All Nite Prayer 2025" >
                    {{ props.row.allnite2025 }}
                </b-table-column-->
                <b-table-column field="allnite2026" label="One Day Prayer 2026" >
                    {{ props.row.allnite2026 }}
                </b-table-column>
                <b-table-column field="circle2025" label="Circle" >
                    {{ props.row.circle2025 }}
                </b-table-column>
                <b-table-column field="age" label="Usia" >
                    {{ props.row.age }}
                </b-table-column>
                <b-table-column field="church_id" label="Gereja" >
                    {{ find_church(props.row.church_id) }}
                </b-table-column>
                <b-table-column field="church_id" label="Total Kehadiran" >
                    {{ props.row.attendance!='' ?props.row.items.length :'' }}
                </b-table-column>
                <b-table-column field="rfid" label="RFID" >
                    {{ props.row.rfid }}
                </b-table-column>
            </template>
            <template slot="detail" slot-scope="props">
              <b-table :data="props.row.items"
              >
                <template slot-scope="props">
                  <b-table-column field="date" label="Tanggal">
                    {{ props.row }}
                  </b-table-column>
                </template>
              </b-table>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="emoticon-sad"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>No result</p>
                    </div>
                </section>
            </template>
        </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';
import FileSaver from 'file-saver'

    export default {
        components: {
        },
        data() {
            return {
                sortField:'id',
                sortOrder:'asc',
                data:[],
                isEmpty: false,
                isHoverable: true,
                loading: false,
                hasMobileCards: false,
                sortIcon:'arrow-up',
                sortIconSize:'is-small',
                defaultSortOrder:'desc',
                search:'',
                show_excel:false,
                gkys:[],
                opened:[],
            }
        },
        watch:{
          dtype(val){
           this.filter_cats(val); 
           this.category='';
          },
        },
        methods:{
          find_church(cat){
            let resp= this.gkys.filter( c=>c.value==cat ) 
            return resp[0].text;
          },
          xls(){
    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>List Peserta Doa</x:Name>';
    tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    tab_text = tab_text + "<table>";
    tab_text = tab_text + document.getElementById('dtable').childNodes[4].childNodes[0].innerHTML;
    tab_text = tab_text + '</table></body></html>';
    var file = new Blob([tab_text], {type: 'application/vnd.ms-excel;charset=utf-8;'});
    FileSaver.saveAs(file,'list_peserta_doa.xls')
          },
          update_data(){
           this.loading=true;
           this.axios.post( env.server+'/person-list',{
             start: 0,
             length: 0,
             sort: this.sortField,
             sort_order: this.sortOrder,
             scfilter: this.search,
           }).then(
             resp=>{
               resp.data=JSON.parse(resp.data);
               this.loading=false;
               this.data=resp.data.data.items;
               this.show_excel=true;
               this.total=resp.data.data.total_results;
               for (var i=0; i<this.data.length; i++ ){
                 this.data[i].idx=i;
                 if ( this.data[i].circle2025=='0') this.data[i].circle2025='';
                 if ( this.data[i].allnite2025=='1970-01-01') this.data[i].allnite2025='';
                 if ( this.data[i].allnite2026=='1970-01-01') this.data[i].allnite2026='';
                 this.data[i].jid=this.data[i].jid.split(/@/)[0]; 
                 this.data[i].items=this.data[i].attendance.split(/,/); 
               }
             }
           );
          },
        },
        mounted(){  
          this.axios.get( env.server+'/church/all').then( resp=>{
                resp.data = JSON.parse(resp.data);
                let arr=[{text:'',value:0}];
                for(let i=0;i<resp.data.data.length;i++){
                   arr.push( { text: resp.data.data[i].name , value: resp.data.data[i].id });
                }
                this.gkys=arr;
          });
        },
    }
</script>
